import { Control } from "react-hook-form";
import {
  BulkExportData,
  BulkExportFormValues,
} from "../../../../types/interaction/BulkExport";
import MultiSelect from "../../../../components/common/MultiSelect/MultiSelect";

interface BulkExportDataTypeDropdownProps {
  control: Control<BulkExportFormValues>;
}

export function BulkExportDataTypeDropdown({
  control,
}: Readonly<BulkExportDataTypeDropdownProps>) {
  return (
    <MultiSelect
      className="mb-4"
      name="dataToExport"
      label="Data to Export"
      size="medium"
      options={[
        { value: BulkExportData.Metadata, label: "Metadata" },
        { value: BulkExportData.Media, label: "Media" },
        { value: BulkExportData.Transcript, label: "Transcript" },
      ]}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      control={control}
      disableClearable
    />
  );
}
